import { datadogRum } from "@datadog/browser-rum";

/**
 * Classe utilitária para reportar erros para o DataDog de forma padronizada
 */
class DatadogErrorReporter {

  static isErrorCode(status){
    return status != null && status >= 400 && status < 600;
  }


  /**
   * Reporta um erro para o DataDog com contexto padronizado
   * @param {Error} error - O erro a ser reportado
   * @param {Object} context - Contexto adicional do erro
   * @param {string} context.function - Nome da função onde ocorreu o erro
   * @param {string} context.url - URL da API que falhou (opcional)
   * @param {Object} context.props - Parâmetros/propriedades enviados (opcional)
   * @param {string} context.errorType - Tipo categorizado do erro
   */
  static reportError(error, context = {}) {
    try {
      const standardizedContext = {
        errorType: context.errorType || "UNKNOWN_ERROR",
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: context.url || null,
        props: context.props || null,
        ...context.additionalInfo,
      };

      datadogRum.addError(error, {
        context: standardizedContext,
      });

      // Log adicional para debug local
      console.error(`[DataDog Error Report] ${context.function}:`, {
        error,
        context: standardizedContext,
      });
    } catch (reportingError) {
      // Fallback caso o próprio reporting falhe
      console.error("Failed to report error to DataDog:", reportingError);
      console.error("Original error:", error);
    }
  }

  /**
   * Reporta erros específicos de APIs com contexto padronizado
   * @param {Error} error - O erro da API
   */
  static reportApiError(error) {
    this.reportError(error, {
      url: error.url,
      props: error.props,
      errorType: "API_REQUEST_FAILED",
      additionalInfo: {
        httpStatus: error?.response?.status || error?.cause?.status || null,
        httpStatusText:
          error?.response?.statusText || error?.cause?.title || null,
        responseData: error?.response?.data || error?.cause || null,
      },
    });
  }
}

export default DatadogErrorReporter;
